import { useQuery } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Alert,
  AlertTitle,
  Button,
  Grid,
  Icon,
  IconButton,
  Typography,
  useMediaQuery,
  Box,
  Paper,
  Chip,
} from "@mui/material";

import { useContext } from "react";

import ImportWizardModal from "./importWizardModal";

import { ImportWizardContext } from "./importWizardProvider";

export default function ImportWizard() {
  const { setOpen } = useContext(ImportWizardContext) as any;

  return (
    <>
      <ImportWizardModal />
      <div style={{ width: "85%", margin: "auto", marginTop: "40px" }}>
        <Box sx={{ marginBottom: "32px" }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ color: "#1976d2" }}
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7,10 12,15 17,10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            </Grid>
            <Grid item xs>
              <Typography variant="h4" sx={{ fontWeight: 600, marginBottom: "8px" }}>
                Import Wizard
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Easily import your data from CSV and Excel files into your workspace
              </Typography>
            </Grid>
            <Grid item>
              <Chip 
                label="Beta" 
                color="warning" 
                variant="outlined" 
                size="small"
                sx={{ marginRight: "16px" }}
              />
              <Button
                variant="contained"
                size="large"
                startIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7,10 12,15 17,10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                }
                onClick={() => {
                  setOpen(true);
                }}
                sx={{ textTransform: "none", fontSize: "16px", padding: "12px 24px" }}
              >
                Start Import
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Alert
          severity="info"
          sx={{ marginBottom: "24px" }}
        >
          This feature is in beta. Please reach out with any questions or issues.
        </Alert>

        <Paper elevation={1} sx={{ padding: "24px", marginBottom: "24px" }}>
          <Typography variant="h6" sx={{ marginBottom: "16px", fontWeight: 600 }}>
            📹 How to Use the Import Wizard
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "16px" }}>
            Watch this quick tutorial to learn how to import your data effectively
          </Typography>
          <div
            style={{
              position: "relative",
              paddingBottom: "33%",
              height: 0,
              maxWidth: "50%",
            }}
          >
            <iframe
              src="https://www.loom.com/embed/0f8031618d5f4696a5a6b106b9059cb0?sid=5578eba5-fab3-4af9-988e-839116115080"
              title="Mercero Import Tutorial"
              allowFullScreen={true}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "8px",
              }}
            />
          </div>
        </Paper>
      </div>
    </>
  );
}
